import { Box, Button, Container, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import LeftSide from "../common/Layout/LeftSide";

function Biometric() {
  return (
    <Container
      maxWidth={false}
      className="container_new bg-lack"
      sx={{ maxWidth: "100%", margin: "0px" }}
    >
      {/* <LeftSide /> */}
      <RightSection className="RightSection">
        <Typography width="100%">
          <Typography
            className="Typography fw-700 mb-10 fs-24 heading"
            width="100%"
          >
            Biometric
          </Typography>
          <Typography
            className="Typography fs-18 mb-50 text-secondary"
            variant="body1"
            sx={{ mb: { xs: 10, sm: 10 } }}
          >
            Enable biometric authentication for quick and secure access to your
            account.
          </Typography>
        </Typography>
        <Box
          width="100%"
         mt='150px'
          height="80%"
          p={8}
          sx={{
            p:{
              xs:'0px'
            },
           
           
            mt:{
              xs:'100px'
            }
            
          }}
          display="flex"
          flexDirection="column"
          justifyContent="start"
          gap="50px"
        >
          <Box display="flex" justifyContent="space-evenly" alignItems="center">
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_325_327)">
                <path
                  d="M34.6667 28C34.6667 25.792 36.4587 24 38.6667 24C40.8747 24 42.6667 25.792 42.6667 28C42.6667 30.208 40.8747 32 38.6667 32C36.4587 32 34.6667 30.208 34.6667 28ZM25.3333 32C27.5413 32 29.3333 30.208 29.3333 28C29.3333 25.792 27.5413 24 25.3333 24C23.1253 24 21.3333 25.792 21.3333 28C21.3333 30.208 23.1253 32 25.3333 32ZM32 53.3333C20.2373 53.3333 10.6667 43.7627 10.6667 32C10.6667 20.2373 20.2373 10.6667 32 10.6667C43.7627 10.6667 53.3333 20.2373 53.3333 32C53.3333 43.7627 43.7627 53.3333 32 53.3333ZM48 32C48 23.176 40.824 16 32 16C23.176 16 16 23.176 16 32C16 40.824 23.176 48 32 48C40.824 48 48 40.824 48 32ZM38.52 35.1147C38.4853 35.136 35.1067 37.3333 32 37.3333C29.4107 37.3333 26.4107 35.728 25.4747 35.112C24.248 34.2987 22.5973 34.632 21.7813 35.856C20.9627 37.08 21.2933 38.7387 22.52 39.5547C23 39.8747 27.328 42.6693 32 42.6693C36.672 42.6693 41 39.8747 41.48 39.5547C42.7067 38.7387 43.0373 37.0827 42.2187 35.856C41.4 34.6293 39.7493 34.2933 38.52 35.1147ZM18.6667 58.6667H13.3333C8.92267 58.6667 5.33333 55.0773 5.33333 50.6667V45.3333C5.33333 43.8613 4.14133 42.6667 2.66667 42.6667C1.192 42.6667 0 43.8613 0 45.3333V50.6667C0 58.0187 5.98133 64 13.3333 64H18.6667C20.1413 64 21.3333 62.8053 21.3333 61.3333C21.3333 59.8613 20.1413 58.6667 18.6667 58.6667ZM61.3333 42.6667C59.8587 42.6667 58.6667 43.8613 58.6667 45.3333V50.6667C58.6667 55.0773 55.0773 58.6667 50.6667 58.6667H45.3333C43.8587 58.6667 42.6667 59.8613 42.6667 61.3333C42.6667 62.8053 43.8587 64 45.3333 64H50.6667C58.0187 64 64 58.0187 64 50.6667V45.3333C64 43.8613 62.808 42.6667 61.3333 42.6667ZM50.6667 0H45.3333C43.8587 0 42.6667 1.19467 42.6667 2.66667C42.6667 4.13867 43.8587 5.33333 45.3333 5.33333H50.6667C55.0773 5.33333 58.6667 8.92267 58.6667 13.3333V18.6667C58.6667 20.1387 59.8587 21.3333 61.3333 21.3333C62.808 21.3333 64 20.1387 64 18.6667V13.3333C64 5.98133 58.0187 0 50.6667 0ZM2.66667 21.3333C4.14133 21.3333 5.33333 20.1387 5.33333 18.6667V13.3333C5.33333 8.92267 8.92267 5.33333 13.3333 5.33333H18.6667C20.1413 5.33333 21.3333 4.13867 21.3333 2.66667C21.3333 1.19467 20.1413 0 18.6667 0H13.3333C5.98133 0 0 5.98133 0 13.3333V18.6667C0 20.1387 1.192 21.3333 2.66667 21.3333Z"
                  fill="#F2674A"
                />
              </g>
              <defs>
                <clipPath id="clip0_325_327">
                  <rect width="64" height="64" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Typography variant="body1" className="text-white">
              or
            </Typography>
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_325_321)">
                <path
                  d="M15.9253 59.4268C15.3424 59.4266 14.7757 59.2355 14.3117 58.8826C13.8478 58.5297 13.5123 58.0345 13.3565 57.4728C13.2007 56.9111 13.2333 56.3138 13.4492 55.7724C13.6651 55.231 14.0525 54.7752 14.552 54.4748C24 48.8001 24 36.6135 24 29.3335C24 27.2117 24.8429 25.1769 26.3431 23.6766C27.8434 22.1763 29.8783 21.3335 32 21.3335C34.1217 21.3335 36.1566 22.1763 37.6569 23.6766C39.1571 25.1769 40 27.2117 40 29.3335C40 30.0407 39.719 30.719 39.219 31.2191C38.7189 31.7192 38.0406 32.0001 37.3333 32.0001C36.6261 32.0001 35.9478 31.7192 35.4477 31.2191C34.9476 30.719 34.6667 30.0407 34.6667 29.3335C34.6667 28.6262 34.3857 27.948 33.8856 27.4479C33.3855 26.9478 32.7072 26.6668 32 26.6668C31.2928 26.6668 30.6145 26.9478 30.1144 27.4479C29.6143 27.948 29.3333 28.6262 29.3333 29.3335C29.3333 37.1921 29.3333 51.8241 17.296 59.0481C16.8818 59.2961 16.4081 59.427 15.9253 59.4268ZM29.16 63.2161C35.2453 57.0828 38.8 48.4588 39.7227 37.5601C39.7538 37.2105 39.7156 36.8582 39.6102 36.5234C39.5049 36.1886 39.3344 35.8779 39.1087 35.6091C38.883 35.3403 38.6065 35.1187 38.295 34.957C37.9834 34.7953 37.6431 34.6967 37.2933 34.6668C36.9434 34.6309 36.5898 34.6658 36.2537 34.7695C35.9175 34.8731 35.6057 35.0433 35.3367 35.27C35.0677 35.4967 34.8471 35.7752 34.688 36.0889C34.5289 36.4027 34.4346 36.7452 34.4107 37.0961C33.5813 46.8481 30.6267 54.1628 25.376 59.4455C24.8774 59.9473 24.5985 60.6266 24.6008 61.334C24.603 62.0413 24.8862 62.7189 25.388 63.2175C25.8898 63.7161 26.5691 63.9949 27.2765 63.9927C27.9839 63.9904 28.6614 63.7073 29.16 63.2055V63.2161ZM43.0267 62.7201C44.6442 60.0325 45.9913 57.191 47.048 54.2375C47.2689 53.5769 47.2226 52.8561 46.919 52.2293C46.6154 51.6024 46.0785 51.1192 45.4233 50.883C44.768 50.6468 44.0463 50.6764 43.4126 50.9654C42.7789 51.2544 42.2833 51.7799 42.032 52.4295C41.0931 55.0483 39.898 57.5681 38.464 59.9521C38.2822 60.2517 38.1613 60.5842 38.108 60.9305C38.0548 61.2769 38.0702 61.6303 38.1536 61.9707C38.2369 62.311 38.3864 62.6316 38.5937 62.9142C38.8009 63.1968 39.0617 63.4357 39.3613 63.6175C39.9664 63.9845 40.6925 64.0962 41.3798 63.9279C41.7202 63.8446 42.0408 63.6951 42.3234 63.4878C42.6059 63.2806 42.8449 63.0197 43.0267 62.7201ZM49.3333 45.8428C50.3213 40.3972 50.7679 34.8671 50.6667 29.3335C50.6641 25.5556 49.5154 21.8674 47.3722 18.7563C45.229 15.6452 42.1922 13.2576 38.6632 11.909C35.1343 10.5605 31.2791 10.3145 27.6074 11.2035C23.9356 12.0925 20.62 14.0747 18.0987 16.8881C17.8531 17.1468 17.662 17.4521 17.5365 17.786C17.411 18.1198 17.3538 18.4755 17.3682 18.8319C17.3826 19.1882 17.4684 19.5381 17.6204 19.8607C17.7725 20.1834 17.9877 20.4722 18.2533 20.7102C18.519 20.9482 18.8296 21.1305 19.167 21.2463C19.5043 21.3621 19.8615 21.409 20.2173 21.3843C20.5731 21.3596 20.9203 21.2638 21.2384 21.1026C21.5566 20.9413 21.8391 20.7179 22.0693 20.4455C23.8701 18.4355 26.2383 17.0194 28.8611 16.3841C31.4838 15.7487 34.2376 15.9242 36.7585 16.8874C39.2794 17.8505 41.4487 19.5558 42.9798 21.7781C44.5108 24.0003 45.3315 26.6349 45.3333 29.3335C45.4317 34.5249 45.019 39.7135 44.1013 44.8241C43.9667 45.5179 44.1129 46.2368 44.5079 46.8228C44.9029 47.4088 45.5144 47.814 46.208 47.9495C46.3775 47.9834 46.5499 48.0003 46.7227 48.0001C47.3403 47.9985 47.9383 47.7826 48.4144 47.3891C48.8906 46.9957 49.2154 46.4491 49.3333 45.8428ZM18.6667 29.3335C18.6659 28.5892 18.7274 27.8462 18.8507 27.1121C18.9303 26.7588 18.9371 26.3929 18.8707 26.0368C18.8042 25.6807 18.6659 25.3419 18.4642 25.0411C18.2625 24.7402 18.0017 24.4836 17.6975 24.2868C17.3934 24.0901 17.0523 23.9574 16.6952 23.8968C16.3381 23.8363 15.9724 23.8491 15.6204 23.9345C15.2683 24.0199 14.9374 24.1762 14.6478 24.3937C14.3582 24.6112 14.1159 24.8855 13.9357 25.1997C13.7556 25.514 13.6414 25.8616 13.6 26.2215C13.424 27.2495 13.3348 28.2905 13.3333 29.3335C13.3333 41.7201 9.744 48.0001 2.66667 48.0001C1.95942 48.0001 1.28115 48.2811 0.781049 48.7812C0.280952 49.2813 0 49.9596 0 50.6668C0 51.3741 0.280952 52.0523 0.781049 52.5524C1.28115 53.0525 1.95942 53.3335 2.66667 53.3335C12.984 53.3335 18.6667 44.8001 18.6667 29.3335ZM55.2 62.4375C59.5885 51.9685 61.68 40.6798 61.3333 29.3335C61.3456 24.9039 60.3422 20.5305 58.4 16.5495C58.2468 16.2343 58.033 15.9524 57.7709 15.7198C57.5087 15.4873 57.2033 15.3087 56.8721 15.1941C56.5409 15.0796 56.1904 15.0314 55.8406 15.0524C55.4908 15.0733 55.1485 15.1629 54.8333 15.3161C54.5182 15.4693 54.2363 15.6831 54.0037 15.9453C53.7712 16.2074 53.5925 16.5128 53.478 16.844C53.3635 17.1752 53.3153 17.5257 53.3362 17.8756C53.3572 18.2254 53.4468 18.5676 53.6 18.8828C55.1868 22.1377 56.0077 25.7124 56 29.3335C56.3357 39.9168 54.4092 50.45 50.3493 60.2295C50.2048 60.5488 50.1246 60.8935 50.1134 61.2439C50.1022 61.5942 50.1602 61.9433 50.284 62.2712C50.4078 62.5992 50.5951 62.8995 50.8351 63.1549C51.0751 63.4104 51.3631 63.6161 51.6827 63.7601C52.0281 63.919 52.4038 64.0009 52.784 64.0001C53.294 63.998 53.7926 63.8496 54.2208 63.5726C54.6491 63.2957 54.9889 62.9017 55.2 62.4375ZM8 37.3335V29.3335C8.00706 22.9704 10.5379 16.87 15.0372 12.3707C19.5366 7.87136 25.637 5.34053 32 5.33347C37.1957 5.31616 42.2538 7.00222 46.4 10.1335C46.9658 10.5578 47.677 10.74 48.3771 10.64C49.0773 10.54 49.709 10.1659 50.1333 9.60014C50.5577 9.03434 50.7399 8.32315 50.6399 7.62301C50.5398 6.92288 50.1658 6.29115 49.6 5.8668C44.5317 2.04126 38.35 -0.0192928 32 0.000136145C24.2231 0.00931074 16.7674 3.10272 11.2683 8.6018C5.76926 14.1009 2.67584 21.5566 2.66667 29.3335V37.3335C2.66667 38.0407 2.94762 38.719 3.44772 39.2191C3.94781 39.7192 4.62609 40.0001 5.33333 40.0001C6.04058 40.0001 6.71885 39.7192 7.21895 39.2191C7.71905 38.719 8 38.0407 8 37.3335Z"
                  fill="#F2674A"
                />
              </g>
              <defs>
                <clipPath id="clip0_325_321">
                  <rect width="64" height="64" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Box>
          <Typography textAlign="center" variant="body1" className="text-white">
            Set up Biometric for the faster account access. We highly recommend
            you to setup now for easier and smooth user experience.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginBottom: "50px" }}
            fullWidth
            className="btn-primary fw-700 fs-18  btn mb-10"
            endIcon={
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 22C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.75 12L10.58 14.83L16.25 9.17004"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
            type="submit"
            //   onClick={() => setIsLogin(true)}
          >
            Enable Biometric
          </Button>
        </Box>

        <Link to="/" className="link">
          Skip
        </Link>
      </RightSection>
    </Container>
  );
}
const RightSection = styled(Box)(({ theme }) => ({
  width: "100%",
  // padding: "4rem",
  display: "flex",
  flexDirection: "column",
  // justifyContent: "space-be",
  alignItems: "center",
  padding:'70px 120px',
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.down("lg")]: {
   
  },
  [theme.breakpoints.down("sm")]: {
   
    padding:'40px 40px'
  },
}));

export default Biometric;
